import { UserType } from '../../types';

type Role = 'admin' | 'architect' | 'superKudu';

export function hasPermission(
  user: UserType | undefined,
  tenantId: string,
  requiredRoles: Array<Role> | 'always'
): boolean {
  if (requiredRoles === 'always') {
    return true;
  }

  if (!user) {
    return false;
  }

  // Check superKudu
  if (user.superKudu && requiredRoles.includes('superKudu')) {
    return true;
  }

  // Check tenant-specific role
  const currentRole = user.permissions?.find(
    (p) => String(p.tenant) === tenantId
  )?.role;

  if (!currentRole) {
    return false;
  }

  // Map role string to Role type
  const roleMap: Record<string, Role> = {
    admin: 'admin',
    architect: 'architect',
    superKudu: 'superKudu',
  };

  const mappedRole = roleMap[currentRole];
  if (!mappedRole) {
    return false;
  }

  return requiredRoles.includes(mappedRole);
}
